<template>
    <div class="user-panel-form clearfix border-xs-btm">
        <div class="form-col">
            <v-select 
                :htmlId="'CountryOfTaxPayee_Country_' + index" 
                :label="'Kraj'" 
                :list="countries"
                :searchable="true"
                :value="item.countryId.toString()" 
                :itemIndex="index" />
        </div>
        <div class="form-col">
            <div class="float-xs-none" style="display: block; float: left; margin-right: 15px;">
                <v-input 
                    :label="'Numer Tin*'" 
                    :htmlId="'CountryOfTaxPayee_Tin_' + index" 
                    :value="!item.lackTin? item.tinNumber : ''"
                    :readonly="item.lackTin"
                    :width="'150px'"
					:maxlength="15"
                    :itemIndex="index" />
            </div>
            <div style="display: block; float: left; margin-right: 15px; margin-top: 18px">
                <v-checkbox
                    :htmlId="'CountryOfTaxPayee_LackTin_' + index"  
                    :checked="item.lackTin"
                    :label="'brak TIN'"
                    :itemIndex="index" />
            </div>

            <div style="display: block; float: left; margin-top: 6px; position: relative;">
                <img
                    src="images/question.png"
                    @mouseover="toggleNoTinTooltip(true)"
                    @mouseout="toggleNoTinTooltip(false)" 
                    class="question-icon"
                    style="margin: 15px 0 0 0;">

                <transition tag="div" name="fade">
                    <div
                        class="tooltip"
                        style="margin-top: -100px; left: -115px; width: 240px; max-width:240px;"
                        v-if="noTinTooltip">Państwo rezydencji podatkowej nie nadało TIN Posiadaczowi Rachunku
                    </div>
                </transition>
            </div>
            <div style="float: right; margin-top: 13px;">
                <button type="button" class="btn btn-secondary" @click="removeOtherCountryTaxItem(index)">Usuń</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            noTinTooltip: false
        }
    },
    props: {
        countries: {
            type: Array,
            required: true
        },
        item:{
            type : Object,
            required : true
        },
        index: {
            type: Number,
            required : true
        }
    },
    methods: {
        removeOtherCountryTaxItem(index){
            this.$store.commit('removeOtherCountryTaxItem', index)
        },
        toggleNoTinTooltip(show) {
            this.noTinTooltip = show
        }
     }
}

</script>